<div class="cbb-field-wrapper">
  <label *ngIf="label" class="cbb-label">{{ label }}</label>
  <div class="cbb-input-shell">
    <input
      [type]="type"
      class="cbb-input"
      [placeholder]="placeholder"
      [value]="value"
      [readOnly]="readonly || isDisabled"
      [class.cbb-input--readonly]="readonly || isDisabled"
      [class.cbb-input--with-clear]="canClear"
      [attr.inputmode]="numericOnly ? 'numeric' : null"
      [attr.min]="min !== undefined ? min : null"
      [attr.step]="step !== undefined ? step : null"
      [appDigitsOnly]="numericOnly"
      (input)="onInput($event)"
      (blur)="onBlur()"
      autocomplete="off"
    />
    <button
      *ngIf="canClear"
      type="button"
      class="cbb-input-clear-btn"
      aria-label="Limpiar campo"
      (click)="clearValue($event)"
    >
      ×
    </button>
  </div>
  <div class="cbb-error-msg" [class.cbb-error-msg--visible]="mensajeError">{{ mensajeError || '&nbsp;' }}</div>
</div>
